import React, { FC, ReactNode } from 'react';
import { useTranslations } from 'next-intl';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { formatThousands } from '@wwe-portal/utils/format';

export const TriviaGameUserStatsItem: FC<{
  icon: string;
  title: string | number;
  description: string;
  tooltip?: ReactNode;
}> = ({ icon, title, description, tooltip }) => {
  const t = useTranslations();
  return (
    <div className="home-item bg-bgColor15 flex h-full w-full flex-col items-center justify-start rounded-xl p-5 text-center 2xl:p-[30px]">
      <div className="bg-bgColor3 mb-4 flex size-[46px] items-center justify-center rounded-full">
        <IcoMoonIcon iconName={icon} className="text-deepSkyBlue mb-0 size-5" />
      </div>
      <span className="mb-4">
        {title && typeof title === 'number'
          ? formatThousands(title) + (description === 'win_rate' ? '%' : '')
          : '-'}
      </span>
      <div className="-mx-5 flex items-center justify-center">
        <span className="text-chetwodeBlue text-sm">{t(description)}</span>
        {tooltip}
      </div>
    </div>
  );
};
